import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import Seo from "@/components/base/Seo";
import PageHeader from "@/components/feature/PageHeader";

const heroImage =
  "https://readdy.ai/api/search-image?query=Soft%20abstract%20editorial%20background%20of%20a%20shield%20icon%20and%20privacy%20concept%20symbols%20subtly%20arranged%20on%20a%20clean%20light%20surface%20with%20warm%20paper%20textures%2C%20minimalist%20composition%2C%20natural%20soft%20daylight%2C%20trustworthy%20calm%20mood%2C%20high%20detail&width=1600&height=500&seq=humanity59-confidentialite-hero&orientation=landscape";

const sections = [
  {
    title: "Responsable du traitement",
    paragraphs: [
      "Le responsable du traitement des données personnelles est l'association Humanity59, située au 12 rue de la Solidarité, 59000 Lille, joignable à l'adresse contact@humanity59.com.",
    ],
  },
  {
    title: "Données collectées",
    paragraphs: [
      "Lors de votre navigation sur ce site, et notamment lors de l'envoi du formulaire de contact ou d'une intention de don, nous pouvons être amenés à collecter les données suivantes : nom, prénom, adresse email, et éventuellement toute information que vous choisissez de nous transmettre dans votre message.",
      "Aucune donnée sensible au sens du Règlement Général sur la Protection des Données (RGPD) n'est collectée sans votre consentement explicite.",
    ],
  },
  {
    title: "Finalités du traitement",
    paragraphs: [
      "Vos données sont collectées pour : répondre à vos demandes de contact et de renseignement, traiter vos intentions de don et l'émission de reçus fiscaux, vous informer de nos actions (uniquement si vous y avez consenti), et améliorer nos services.",
    ],
  },
  {
    title: "Base légale",
    paragraphs: [
      "Le traitement de vos données repose sur votre consentement, l'exécution d'un contrat (notamment en cas de don), ou l'intérêt légitime de l'association à mener ses missions d'intérêt général.",
    ],
  },
  {
    title: "Durée de conservation",
    paragraphs: [
      "Vos données sont conservées pendant la durée nécessaire aux finalités pour lesquelles elles ont été collectées, et au maximum pendant 3 ans à compter de votre dernier contact, sauf obligations légales spécifiques (notamment comptables et fiscales, qui peuvent imposer une conservation plus longue).",
    ],
  },
  {
    title: "Destinataires des données",
    paragraphs: [
      "Vos données sont destinées aux seuls membres habilités de l'association Humanity59. Elles ne sont jamais vendues ni cédées à des tiers à des fins commerciales. Elles peuvent être transmises à des prestataires techniques (hébergeur, outil de formulaire) uniquement dans la mesure nécessaire à l'exécution de leurs services.",
    ],
  },
  {
    title: "Cookies",
    paragraphs: [
      "Le site peut utiliser des cookies strictement nécessaires à son bon fonctionnement. Aucun cookie publicitaire ou de mesure d'audience n'est déposé sans votre consentement préalable. Vous pouvez configurer votre navigateur pour refuser les cookies à tout moment.",
    ],
  },
  {
    title: "Vos droits",
    paragraphs: [
      "Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, d'effacement, de limitation, de portabilité et d'opposition concernant vos données personnelles. Vous pouvez également retirer votre consentement à tout moment.",
      "Pour exercer ces droits, contactez-nous par email à contact@humanity59.com. Vous disposez également du droit d'introduire une réclamation auprès de la CNIL (www.cnil.fr).",
    ],
  },
  {
    title: "Sécurité",
    paragraphs: [
      "Nous mettons en œuvre des mesures techniques et organisationnelles appropriées afin de protéger vos données contre tout accès non autorisé, perte, altération ou divulgation.",
    ],
  },
];

export default function PolitiqueConfidentialite() {
  return (
    <div className="min-h-screen flex flex-col">
      <Seo
        title="Politique de confidentialité | Humanity59"
        description="Politique de confidentialité d'Humanity59 : collecte et utilisation de vos données personnelles, cookies et vos droits RGPD."
        keywords="politique de confidentialité, données personnelles, RGPD, cookies"
        path="/politique-de-confidentialite"
      />
      <Header />
      <main className="flex-1">
        <PageHeader
          title="Politique de confidentialité"
          subtitle="Comment nous collectons, utilisons et protégeons vos données personnelles."
          image={heroImage}
        />

        <section className="py-16 md:py-24 bg-background-50">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <p className="text-sm text-foreground-500">
              Dernière mise à jour : 19 août 2026
            </p>

            <div className="mt-8 space-y-12">
              {sections.map((section) => (
                <article key={section.title}>
                  <h2 className="font-heading text-2xl font-bold text-foreground-950">
                    {section.title}
                  </h2>
                  <div className="mt-4 space-y-4">
                    {section.paragraphs.map((paragraph, index) => (
                      <p
                        key={index}
                        className="text-base text-foreground-600 leading-relaxed"
                      >
                        {paragraph}
                      </p>
                    ))}
                  </div>
                </article>
              ))}
            </div>

            <div className="mt-12 rounded-lg border border-primary-200 bg-primary-100/50 p-6">
              <p className="text-sm text-primary-700 leading-relaxed">
                <i className="ri-shield-check-line mr-1.5"></i>
                Pour toute question relative à vos données personnelles,
                contactez-nous à l'adresse{" "}
                <a
                  href="mailto:contact@humanity59.com"
                  className="font-semibold underline cursor-pointer"
                >
                  contact@humanity59.com
                </a>
                .
              </p>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}